import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useRouter } from 'next/router';
import { apiClientV2 } from '~/api/client';

export const useGetIGInsights = ({ id }: { id?: string }) => {
  const router = useRouter();

  return useQuery({
    queryKey: ['insights-instagram', { id }],
    queryFn: () => {
      if (router.asPath.includes('/media-kits/')) {
        // GET data using SSR Token for media kits
        return axios
          .get<IGInsights>(`/api/insights/${id}/ig`)
          .then((r) => r.data);
      }

      return apiClientV2
        .get<IGInsights>(`/creator-insights/${id}`)
        .then((r) => r.data);
    },
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export interface IGInsights {
  id: string;
  ages?: LabelValuePair[];
  gendersPerAge?: GendersPerAgeEntity[];
  genders?: LabelValuePair[];
  cities?: LabelValuePair[] | null;
  countries?: CountriesEntity[];
  createdAt: string;
  updatedAt: string;
  agesShort?: LabelValuePair[] | null;
  demographicsLastUpdatedAt: string;
  demographicsSource?: string;
}

export interface LabelValuePair {
  label: string;
  value: number;
}
export interface GendersPerAgeEntity {
  label: string;
  values?: LabelValuePair[] | null;
}
export interface CountriesEntity {
  label: string;
  value: number;
  meta: Meta;
}
interface Meta {
  countryName: string;
}
